<app-list-view
  [service]="categoriesService"
  [displayedColumns]="['id', 'categori']"
></app-list-view>
